import React, {Component} from "react";
import ProgressIndicator from "./ProgressIndicator";
import {ExternalWindow as ExternalWindowSvg} from "@vitalsource/vstui-icons";
import styled from "styled-components";
import {Icon} from "@vitalsource/vstui";
import LinkWithGATracker from "../LinkWithGATracker";
import {Button} from "@vitalsource/vstui";
import uploadIcon from "../../../img/arrow-upload.svg"
import {ProgressObject} from "../../reducers";
import { ErrorResponse } from "../../types/StudioAPITypes";
import "../../../styles/FileImportProgressIndicator.css"
import {
  DUPLICATE_PRODUCT_NAME_API_ERROR,
  FILE_SIZE_EXCEEDS_LIMIT_ERROR,
  INVALID_FILE_CONTENT_TYPE_ERROR
} from "../../utils/constants";

export interface FileImportProgressIndicatorProps {
  children: React.ReactNode;
  progressInfo: ProgressObject;
  handleClose: () => void;
  handleUploadRetry: () => void;
  resetImportProcess: () => void;
  error: ErrorResponse
}

const LearnMoreIcon = styled(Icon)`
  position: relative;
  top: 2px;
  left: 5px;
`;

const ErrorButton = styled(Button)`
  margin: 16px auto 16px auto;
  position: relative;
  display: block;
`;

export default class FileImportProgressIndicator extends Component<FileImportProgressIndicatorProps> {
  constructor(props: any) {
    super(props);

    this.renderOnSuccess = this.renderOnSuccess.bind(this);
  }

  componentWillUnmount() {
    this.props.resetImportProcess()
  }

  getInProgressMessage() {
    return (
      <>
        <div>Uploading your file...</div>
        <div>Refreshing or navigating away will interrupt file upload.</div>
      </>)
  };

  getProgressCompleteMessage() {
    return (
      <div>Upload complete!</div>
    )
  };

  generateFailureMessageFromServer() {
    if (this.props.error) {
      if (this.props.error.messageid === FILE_SIZE_EXCEEDS_LIMIT_ERROR) {
        return "File exceeds 750 MB limit."
      } else if (this.props.error.messageid === INVALID_FILE_CONTENT_TYPE_ERROR) {
        return "Unsupported file type"
      } else if (this.props.error.messageid === DUPLICATE_PRODUCT_NAME_API_ERROR) {
        return (<p><div>Product name exists...</div>
                <div>Change file name and try again.</div></p>)
      } else {
        return "File upload failed... Try again."
      }
    }
    return ""
  }

  getFailureMessage() {
    return (<div>
      <div className={"err-msg"}>{this.generateFailureMessageFromServer()}</div>
      <div className={"err-msg-btn-container"}>
        <ErrorButton onClick={ () => {
          this.props.resetImportProcess();
          this.props.handleUploadRetry();
        }}>Select File...</ErrorButton>
        <ErrorButton color={"white"} onClick={ () => {
          this.props.resetImportProcess();
          this.props.handleClose();
        }}>Cancel</ErrorButton>
      </div>
    </div>)
  }

  renderOnSuccess() {
    return (<div className={"import-content-message-container"}>
        <div className={"import-content-message__header"}>Import Content</div>
        <p>This may take a few minutes. Content will continue importing while you work elsewhere.</p><br/>
        <p>We recommend a thorough review of your content after the import.</p>
        <LinkWithGATracker
        href={`${process.env.PUBLIC_URL}/support/StudioPDFImport.pdf`}
        className='import-content-message__link'
        onClick={(e: any) => {
          e.stopPropagation()
        }}
        target="_blank"><>Learn More</>
        <LearnMoreIcon height={16} width={16}><ExternalWindowSvg/></LearnMoreIcon>
        </LinkWithGATracker>
        <Button className={"import-content-message__btn"}
                fullWidth size="large"
                onClick={ () => {
                  this.props.handleClose()
                }}
        >Start Import</Button>
    </div>)
  }

  render() {
    return <ProgressIndicator className={"import_progress-indicator__container"}
                              size="large"
                              progressInfo={this.props.progressInfo}
                              icon={uploadIcon}
                              inProgressMessage={this.getInProgressMessage()}
                              progressCompleteMessage={this.getProgressCompleteMessage()}
                              progressFailureMessage={this.getFailureMessage()}
                              onSuccess={this.renderOnSuccess}
    >{this.props.children}</ProgressIndicator>;
  }
}
